<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="pb-5 d-flex justify-center">
        <v-dialog
                v-model="isOpen"
                fullscreen
                transition="dialog-bottom-transition"
                content-class="editing-dialog"
                width="100%"
        >
            <v-toolbar flat dark class="main--yellow">
                <order-dialog-products></order-dialog-products>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn text @click="send" :disabled="!isValidOrder">
                        {{ $t('send') }}
                    </v-btn>
                    <v-btn text @click="closeDialog">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card>
                <v-card-title class="text-center">{{ $t('orderCreating') }}</v-card-title>
                <v-card-text>
                    <v-form v-model="isValidOrder">
                        <v-row сlass="pb-4 d-flex flex-wrap" cols="12">
                            <v-col cols="12" xs="12" sm="4">
                                <v-text-field
                                        :label="$t('nameSurname')"
                                        color="orange lighten-2"
                                        v-model="customerName"
                                        :rules="rules.name"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" xs="12" sm="4">
                                <v-text-field
                                        :label="$t('telephone')"
                                        color="orange lighten-2"
                                        v-model="customerPhone"
                                        :rules="rules.phone"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" xs="12" sm="4">
                                <v-text-field
                                        label="E-mail"
                                        color="orange lighten-2"
                                        v-model="customerEmail"
                                        required
                                        :rules="rules.email"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row сlass="pb-4 d-flex">
                            <v-col cols="12" xs="12" sm="4">
                                <v-autocomplete
                                        v-model="model.region"
                                        :items="regions"
                                        hide-no-data
                                        item-text="name"
                                        item-value="id"
                                        :label="$t('region')"
                                        return-object
                                        color="orange lighten-2"
                                        @change="regionChange"
                                        :rules="rules.region"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" xs="12" sm="4">
                                <v-autocomplete
                                        v-model="model.geo"
                                        :items="settlements"
                                        hide-no-data
                                        item-text="name"
                                        item-value="id"
                                        :label="$t('settlement')"
                                        return-object
                                        color="orange lighten-2"
                                        :disabled="!settlements.length"
                                        :loading="settlementsLoad"
                                        :rules="rules.city"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" xs="12" sm="4">
                                <v-text-field
                                        :label="$t('address')"
                                        color="orange lighten-2"
                                        v-model="model.address"
                                        :rules="rules.address"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" xs="12" sm="12" class="d-md-flex d-sm-block">
                                <v-col cols="12" xs="12" sm="6" md="6" class="d-md-flex d-sm-block pt-0">
                                    <v-col sm="12" md="6" lg="6" class="radio-btn pt-0">
                                        <div class="subtitle-1 font-weight-bold pa-3 pl-0">{{$t('paymentMethod')}}</div>
                                        <v-radio-group
                                                v-model="model.paymentWay"
                                                v-for="payment in paymentWays"
                                                :key="payment.id"
                                                :rules="rules.paymentWay"
                                        >
                                            <v-radio
                                                    :label="payment.name"
                                                    :value="payment.id"
                                                    color="orange lighten-2"
                                                    class="pa-0 ma-0"
                                            ></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                    <v-col sm="6" md="6" lg="6" class="radio-btn pt-0">
                                        <div class="subtitle-1 font-weight-bold pa-3 pl-0">{{$t('delivery')}}</div>
                                        <v-radio-group column v-model="model.deliveryTo">
                                            <v-radio
                                                    :label="$t('asSoonPossible')"
                                                    :value="-1"
                                                    color="orange lighten-2"
                                                    class="px-0 pb-3 ma-0"
                                                    @click.native="picker = null"
                                            ></v-radio>
                                            <v-radio
                                                    :label="dateLabel"
                                                    :value="picker"
                                                    color="orange lighten-2"
                                                    class="pa-0 ma-0"
                                                    @click.native="menu = !menu"
                                            ></v-radio>
                                            <v-menu
                                                    ref="menu"
                                                    v-model="menu"
                                                    :close-on-content-click="false"
                                                    :return-value.sync="picker"
                                                    transition="scale-transition"
                                                    width="220"
                                            >
                                                <v-date-picker
                                                        v-model="picker"
                                                        header-color="orange lighten-2"
                                                        color="orange lighten-2"
                                                        locale="ru"
                                                        width="298"
                                                >
                                                    <v-spacer></v-spacer>
                                                    <v-btn text  color="orange lighten-2" @click="menu = false">Назад</v-btn>
                                                    <v-btn text  color="orange lighten-2" @click="$refs.menu.save(picker)">Выбрать</v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-radio-group>

                                    </v-col>
                                </v-col>
                                <v-col cols="12" xs="12" sm="6" md="6">
                                    <v-textarea
                                            v-model="model.message"
                                            solo
                                            :label="$t('messagesToSeller')"
                                            auto-grow
                                            name="text-to-seller"
                                            class="border-transparent"
                                            color="orange lighten-2"
                                            outlined
                                            height="300"
                                    ></v-textarea>
                                </v-col>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snack" :color="snackColor">
            {{ snackText }}
        </v-snackbar>
    </div>
</template>

<script>
    import '../new-purchase/new-purchase.scss'
    import BasketService from '../../../app-front/services/api/BasketService';
    import GeoService from '../../../app-front/services/api/GeoService';
    import OrderDialogProducts from './OrderDialogProducts';

    export default {
        name: "OrderDialog",
        props: ['orderType'],
        components: {OrderDialogProducts},
        data() {
            return {
                basketData: {},
                e1: 1,
                isValidOrder: false,
                picker: null,
                menu: false,
                dialog: false,
                model: {},
                rules: {
                    address: [
                        v => !!v || this.$t('requiredField'),
                    ],
                    city: [
                        v => !!v || this.$t('requiredField'),
                    ],
                    email: [
                        v => !!v || this.$t('requiredField'),
                        v => /.+@.+/.test(v) || this.$t('emailInvalid'),
                    ],
                    name: [
                        v => !!v || this.$t('requiredField'),
                    ],
                    paymentWay: [
                        v => !!v || this.$t('requiredField'),
                    ],
                    phone: [
                        v => !!v || this.$t('requiredField'),
                    ],
                    region: [
                        v => !!v || this.$t('requiredField'),
                    ],
                },
                settlements: [],
                settlementsLoad: false,
                snack: false,
                snackColor: null,
                snackText: null,
            }
        },
        computed: {
            dateLabel() {
                let label = 'Выбрать дату';

                if(this.picker) {
                    label += ` (${this.picker})`;
                }

                return label;
            },
            isOpen: {
                get() {
                    return this.$store.state.order.openDialog;
                },
                set(value) {
                    this.closeDialog();
                }
            },
            orderIds() {
                return this.$store.state.order.products;
            },
            orderProducts() {
                const ids = this.orderIds;

                return this.storeBasketItems.filter(item => ids.indexOf(item.productId) > - 1)
            },
            paymentWays() {
                return this.$store.state.baseInfo.paymentWays;
            },
            customerName: {
                get() {
                    const profileData = this.$store.state.account.profileData;

                    if(profileData.firstName && profileData.lastName) {
                        return profileData.firstName.toString() + ' ' + profileData.lastName.toString();
                    } else {
                        return '';
                    }
                },
                set(value) {
                    this.model.name = value
                }
            },
            customerEmail: {
                get() {
                    const profileData = this.$store.state.account.profileData;

                    if(profileData.email) {
                        return profileData.email.toString();
                    } else {
                        return '';
                    }
                },
                set(value) {
                    this.model.email = value
                }
            },
            customerPhone: {
                get() {
                    const profileData = this.$store.state.account.profileData;

                    if(profileData.phone && profileData.phone.clear) {
                        return profileData.phone.clear.toString();
                    } else {
                        return '';
                    }
                },
                set(value) {
                    this.model.email = value
                }
            },
            regions() {
                return this.$store.state.geo.regions;
            },
            storeBasketItems() {
                return this.$store.state.basket.items;
            },
            sendData() {
                const sendData = {
                    customer: this.model
                };

                sendData.products = this.orderProducts.map(item => {
                    return {
                        packID: item.pack.id,
                        price: item.calculatedPrice,
                        currency: item.price.currency,
                        productID: item.productId,
                        quantity: item.quantity
                    };
                });

                return sendData;
            }
        },
        methods: {
            closeDialog() {
                this.$store.commit('orderCloseDialog');
            },
            regionChange() {
                this.settlementsLoad = true;
                this.settlements = [];
                this.model.geo = null;
                GeoService.setLocale(this.$store.state.language.appLanguage);
                GeoService.getChildrenSettlements(this.model.region.id)
                    .then(res => {
                        this.settlements = res.data;
                        this.settlementsLoad = false;
                    })
                    .catch(err => console.log(err))
            },
            send() {
                this.$store.commit('orderCloseDialog');
                BasketService.createBasketOrder(this.sendData)
                    .then(res => {
                        if(res.data.success.length) {
                            this.updateStore(res.data.success);
                            this.snackSuccess();
                        }

                        if(res.data.error.length) {
                            this.snackError();
                        }
                    })
                    .catch(err => {
                        this.snackError();
                        console.log(err);
                    });
            },
            snackError() {
                this.snackColor = 'error';
                this.snackText = this.$t('orderError');
                this.snack = true;
            },
            snackSuccess() {
                this.snackColor = 'success';
                this.snackText = this.$t('orderSuccess');
                this.snack = true;
            },
            updateStore(ids) {
                const basketItems = this.storeBasketItems.filter(item => ids.indexOf(item.productId) < 0);
                const orderIds = this.orderIds.filter(item => ids.indexOf(item) < 0);
                this.$store.commit('setBasket', basketItems);
                this.$store.commit('orderSetProducts', orderIds);
            }
        },
        watch: {
            picker() {
                this.model.deliveryTo = this.picker;
            }
        }
    }
</script>

<style scoped>

</style>
